export default "./images/survio-2sMnd-assets-Card-24.svg";